// Process is provided by webpack DefinePlugin at build time
declare const process: {env: {REACT_APP_AI_GATEWAY_URL?: string}};

export const SimpleUUID = () =>
	typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2, 11);

export const COLOR_OPTIONS = ['#E8A838', '#6e0fea', '#e63946', '#5ccb66', '#44b4ff', '#ff7c75'];

export const AGENT_URL: string = process.env.REACT_APP_AI_GATEWAY_URL || 'http://localhost:7861';

export const TOOL_LABELS: Record<string, string> = {
	get_current_datetime: 'ai_project_planning.tool_get_current_datetime',
	get_portfolio_health: 'ai_project_planning.tool_get_portfolio_health',
	get_roles: 'ai_project_planning.tool_get_roles',
	get_team_availability: 'ai_project_planning.tool_get_team_availability',
	get_person_utilisation: 'ai_project_planning.tool_get_person_utilisation',
	get_leave: 'ai_project_planning.tool_get_leave',
	create_project: 'ai_project_planning.tool_create_project',
	create_allocation: 'ai_project_planning.tool_create_allocation',
	get_person: 'ai_project_planning.tool_get_person',
	add_project_team_member: 'ai_project_planning.tool_add_project_team_member',
	__refining__: 'ai_project_planning.tool_refining',
};

export const SUGGESTIONS = [
	'Build an e-commerce platform with a frontend and backend developer over 3 months',
	'Plan a mobile app redesign with a designer and 2 engineers for 6 weeks',
	'Set up a data pipeline project with a data engineer starting next month',
];

export const BUDGET_TYPE_MAP: Record<string, string> = {
	FIXED_PRICE: 'Fixed Price',
	TIME_AND_MATERIALS: 'T&M',
	NON_BILLABLE: 'Non-Billable',
	RETAINER: 'Retainer',
};

export const BUDGET_TYPE_REVERSE_MAP: Record<string, string> = {
	'Fixed Price': 'FIXED_PRICE',
	'T&M': 'TIME_AND_MATERIALS',
	'Non-Billable': 'NON_BILLABLE',
	Retainer: 'RETAINER',
};

export function getAvatarColor(name: string): string {
	let hash = 0;
	for (let i = 0; i < name.length; i++) {
		hash = name.charCodeAt(i) + ((hash << 5) - hash);
	}
	return COLOR_OPTIONS[Math.abs(hash) % COLOR_OPTIONS.length];
}

export function getInitials(name: string): string {
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2) {
		return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
	}
	return (parts[0] || '?')[0].toUpperCase();
}
